<template>
  <b-modal
    :visible="visible"
    hide-footer
    button-size="sm"
    size="xl"
    modal-cancel="false"
    no-close-on-backdrop
    @close="close"
    id="courses-offered-list"
  >
    <template v-slot:modal-title>Lista de cursos</template>
    <section class="container-fluid">
      <CRow>
        <CCol md="12">
          <CCard>
            <CCardHeader>
              <slot name="header">
                <div class="row">
                  <div class="col-12 col-xl-5">
                    <template v-if="teacher !== null">
                      <span>
                        <b>Profesor:</b>
                        {{ teacher.person.fullname }}</span
                      >
                    </template>
                  </div>
                  <div class="col-12 col-xl-7">
                    <div class="row">
                      <div class="col-2 col-xl-1 text-right">
                        <div class="form-group">
                          <label
                            class="control-label"
                            for="courses_offered_year"
                            >Gestión:</label
                          >
                        </div>
                      </div>
                      <div class="col-12 col-xl-4">
                        <div class="form-group">
                          <b-form-select
                            v-model="columnFilter.courses_offered_year"
                            :options="coursesOfferedYearsOptions"
                            id="courses_offered_year"
                            size="sm"
                            @change="filterTable"
                          >
                          </b-form-select>
                        </div>
                      </div>
                      <div class="col-12 col-xl-1">
                        <div class="form-group">
                          <label class="control-label" for="period"
                            >Periodo:</label
                          >
                        </div>
                      </div>
                      <div class="col-12 col-xl-4">
                        <div class="form-group">
                          <b-form-select
                            v-model="columnFilter.period"
                            :options="periodOptions"
                            value-field="value"
                            text-field="name"
                            id="period"
                            size="sm"
                            @change="filterTable"
                          >
                          </b-form-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </slot>
            </CCardHeader>
            <CCardBody>
              <CDataTable
                class="table-bordered c-table c-table-main"
                :hover="true"
                :striped="true"
                :bordered="true"
                :small="true"
                :items="items"
                :fields="fields"
                :sorter="{ external: true, resetable: true }"
                @update:sorter-value="filterTable"
                :columnFilter="{ external: true, lazy: true }"
                @update:column-filter-value="filterTable"
                :column-filter-value.sync="columnFilter"
                :loading="loading"
              >
                <template #no-items-view>
                  <div class="no-items-view">
                    {{
                      loading
                        ? "Cargando datos..."
                        : "No existen cursos registrados"
                    }}
                    <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                  </div>
                </template>
                <!-- filters -->
                <template #type_of_course-filter>
                  <v-select
                    :options="typeOfCourseOptions"
                    label="name"
                    :reduce="(typeOfCourse) => typeOfCourse.value"
                    v-model="columnFilter.type_of_course"
                    @input="filterTable"
                  ></v-select>
                </template>
                <template #syllabus_description-filter>
                  <v-select
                    :options="syllabusOptions"
                    label="description"
                    :reduce="(syllabus) => syllabus.id"
                    v-model="columnFilter.syllabus_id"
                    @input="filterTable"
                  ></v-select>
                </template>
                <template #detail-filter>
                  <b-button
                    @click="reload"
                    variant="secondary"
                    size="sm"
                    title="Recargar tabla"
                  >
                    <CIcon size="sm" name="cil-reload" />
                  </b-button>
                  <b-button
                    @click="clean"
                    variant="secondary"
                    size="sm"
                    title="Limpiar filtros"
                  >
                    <CIcon size="sm" name="cil-filter-x" />
                  </b-button>
                </template>
                <!-- data -->
                <template #id="{ index }">
                  <td>{{ (page - 1) * limit + (index + 1) }}</td>
                </template>
                <template #period="{ item }">
                  <td>{{ `${item.period}/${item.courses_offered_year}` }}</td>
                </template>
                <template #course_name="{ item }">
                  <td>
                    {{ item.course_name }}
                  </td>
                </template>
                <template #parallel="{ item }">
                  <td>
                    {{ item.parallel != 'NONE' ? item.parallel : 'NONE'  }}
                  </td>
                </template>
                <template #type_of_course="{ item }">
                  <td>{{ item.type_of_course | type_of_course }}</td>
                </template>
                <template #syllabus_description="{ item }">
                  <td>
                    {{
                      item.syllabus_description + " v." + item.syllabus_version
                    }}
                  </td>
                </template>
                <template #enabled="{ item }">
                  <td>
                    <CBadge color="success" v-if="item.enabled == true"
                      >Activo</CBadge
                    >
                    <CBadge color="danger" v-else>Inactivo</CBadge>
                  </td>
                </template>
                <template #detail>
                  <td></td>
                </template>
              </CDataTable>
            </CCardBody>
            <div>
              <CPagination
                :activePage.sync="page"
                :pages="pages"
                size="sm"
                align="center"
                @update:activePage="updateTable"
              />
              <TableRecords
                :total="total"
                :loading="loading"
                :from="from"
                :to="to"
                :page="page"
              />
            </div>
          </CCard>
        </CCol>
      </CRow>
    </section>
  </b-modal>
</template>
<script>
import {
  BAlert,
  BModal,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import CoursesOffered from "@/plugins/services/courses-offered";
import Teachers from "@/plugins/services/teachers";
import Syllabus from "@/plugins/services/syllabus";

export default {
  name: "CoursesOfferedListModal",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    TableRecords,
    BFormSelect,
    BFormSelectOption,
  },
  props: {
    modShowCoursesOfferedList: { type: Boolean, required: true },
    teacher_id: { type: Number, required: true },
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width: 8px;",
        },
        {
          key: "period",
          label: "Periodo",
          _style: "width: 8%;",
          sorter: false,
          filter: false,
        },
        {
          key: "course_name",
          label: "Curso",
        },
        {
          key: "parallel",
          label: "Paralelo",
        },
        {
          key: "syllabus_description",
          label: "Pensum",
          sorter: false,
          _style: "width: 20%;",
        },
        {
          key: "type_of_course",
          label: "Tipo de curso",
          _style: "width: 20%;",
          filter: false,
        },
        {
          key: "detail",
          label: "Acciones",
          sorter: false,
          _style: "width: 110px;",
        },
      ],
      items: [],
      teacher: null,
      columnFilter: { column: null, asc: false, enabled: true },
      coursesOfferedYearsOptions: [],
      periodOptions: Constants.periodOptions,
      typeOfCourseOptions: Constants.typeOfCourseOptions,
      enabledOptions: Constants.enabledOptions,
      syllabusOptions: [],
      page: 0,
      pages: 0,
      limit: 20,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      dataEmit: { modalShow: false, data: null },
    };
  },
  mounted() {
    this.columnFilter.courses_offered_year = Utils.getYear(this.userAuth.now);
    this.columnFilter.teacher_id = this.teacher_id;
    this.getTeacher(this.teacher_id);
    this.getAll(this.columnFilter);
    this.getCoursesOfferedYears();
    this.getSyllabus();
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modShowCoursesOfferedList;
    },
  },
  methods: {
    getTeacher(id) {
      Teachers.getOne(id)
        .then((res) => {
          this.teacher = res.data;
        })
        .catch((err) => {
          if (err.response && err.response.status == 404) {
            Utils.setFlash("danger", "Profesor no encontrado.");
            this.closeModal();
          }
          if (err.response && err.response.status == 500) {
            Utils.setFlash("danger", "Error de servidor.");
            this.closeModal();
          }
          this.dataLoader = false;
        });
    },
    getAll(q = null, page = null) {
      this.loading = true;
      CoursesOffered.indexSchedule(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        column: null,
        asc: false,
        enabled: true,
        courses_offered_year: Utils.getYear(this.userAuth.now),
        teacher_id: this.teacher_id,
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter, this.page);
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears(this.userAuth.now);
    },
    // search Syllabus
    getSyllabus() {
      Syllabus.selectAll({ enabled: true })
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeModal(data = null) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.$emit("coursesOfferedListModal", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
